import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/non-vendor/environment';
import { constants } from 'src/environments/constants';
import { DataService } from './data.service';
import { InsightDataService } from './insight/insight-data.service';
import { MockDataService } from './mock-data.service';
import { CdwDataService } from './cdw/cdw-data.service';
import { SynnexDataService } from './synnex/synnex-data.service';
import { ConnectionDataService } from './connection/connection-data.service';
import { TraferaDataService } from './trafera/trafera-data.service';
import { BluumDataService } from './bluum/bluum-data.service';
import { DAndHDataService } from './dandh/dandh-data.service';
import { SynnexAusDataService } from './synnex-aus/synnex-aus.service';
import { VivacityDataService } from './vivacity/vivacity-data.service';
import { PromevoDataService } from './promevo/promevo-data.service';

@Injectable({
  providedIn: 'root'
})
export class DataFactoryService {

  constructor(private injector: Injector) { }

  getDataService(): DataService {
    switch (environment.name) {
      case constants.SANDBOX:
        return this.injector.get(MockDataService);
      case constants.INSIGHT:
      case constants.INSIGHT_EDU:
      case constants.DEMO:
      case constants.DEMO_EDU:
      case constants.DEFAULT:
        return this.injector.get(InsightDataService);
      case constants.DANDH:
        return this.injector.get(DAndHDataService);
      case constants.CDW:
      case constants.CDWG:
        return this.injector.get(CdwDataService);
      case constants.BLUUM:
        return this.injector.get(BluumDataService);
      case constants.SYNNEX:
        return this.injector.get(SynnexDataService);
      case constants.SYNNEX_Public:
        return this.injector.get(SynnexDataService);
      case constants.CONNECTION:
        return this.injector.get(ConnectionDataService);
      case constants.CONNECTION_GOV:
        return this.injector.get(ConnectionDataService);
      case constants.TRAFERA:
        return this.injector.get(TraferaDataService);
      case constants.SYNNEX_AUS:
        return this.injector.get(SynnexAusDataService);
      case constants.VIVACITY:
        return this.injector.get(VivacityDataService);
      case constants.PROMEVO:
        return this.injector.get(PromevoDataService)
      default:
        return this.injector.get(MockDataService);
    }
  }
}
